import { useState, useEffect, useCallback } from 'react';
import { listIpBlocks, liftIpBlock, IpBlock, PaginatedResult } from '../api/admin';

interface UseAdminIpBlocksOptions {
  page: number;
  pageSize: number;
}

interface UseAdminIpBlocksResult {
  data: PaginatedResult<IpBlock> | null;
  loading: boolean;
  lifting: string | null;
  refresh: () => Promise<void>;
  lift: (ipHash: string) => Promise<void>;
}

export function useAdminIpBlocks({ page, pageSize }: UseAdminIpBlocksOptions): UseAdminIpBlocksResult {
  const [data, setData]       = useState<PaginatedResult<IpBlock> | null>(null);
  const [loading, setLoading] = useState(true);
  const [lifting, setLifting] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await listIpBlocks({ page, pageSize });
      setData(res.data.data);
    } finally {
      setLoading(false);
    }
  }, [page, pageSize]);

  useEffect(() => { fetch(); }, [fetch]);

  const refresh = useCallback(async () => { await fetch(); }, [fetch]);

  const lift = useCallback(async (ipHash: string) => {
    setLifting(ipHash);
    try {
      await liftIpBlock(ipHash);
      await fetch();
    } finally {
      setLifting(null);
    }
  }, [fetch]);

  return { data, loading, lifting, refresh, lift };
}
